<!--
 * @Author: W9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-01 18:26:49
 * @LastEditors: W9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2024-03-19 12:03:51
 * @FilePath: \community-backendf:\community-frontend\src\App.vue
 * @Description: 
-->

<template>
  <!-- 头部导航 -->
  <Notice />
  <component
    :is="NavComponent" 
    @init="showRoute = true"
  />
  <ContentCenterNav />
  <Suspense>
    <router-view v-slot="{ Component, route }">
      <keep-alive :max="5" exclude="commentEditor">
        <component :is="Component" :key="route.name"/>
      </keep-alive>
    </router-view>
  </Suspense>
  <FootComponent v-if="footVisible" />
  <div :class="`cookie-bottom${isWeb ? '' : '-wap'}`" v-if="showAgreement && !sawAgreement">
    <p>{{$t('bottomCookie')}}
      <a @click="linkToCookies">{{$t('readMore')}}.</a>
    </p>
    <svg-icon @click="closeCookie" class="cookie-close" name="icon-close" />
  </div>
  <OpenApp v-if="openAppVisible"/>
  <LoginComponent v-model="loginPoperVisible"></LoginComponent>

</template>

<script setup>

import setRootCssProperties from '@/utils/setRootCssProperty'
import languageList from '@/lang/languageList.json'

import { storeToRefs } from 'pinia'
import { useUserStore } from '@/stores/user'
import { useSystemStore } from '@/stores/system'

import { regPush } from '/public/regPush' 
import { onFocus, onBlur } from '@/hooks/windowState';
import { nextTick, onMounted, reactive } from 'vue'

import { renderDialog, unmountDialog } from '@/utils/dialogRenderer'


const route = useRoute()
const userStore = useUserStore()
const systemStore = useSystemStore()

const { proxy } = getCurrentInstance()
const { uid, loginPoperVisible } = storeToRefs(userStore)
const { isEurop, isWeb, isWap, isWechat, cloudConfig, customSetting, isApp, appName, isOppoApp, isAppMarket, isCommunityApp } = storeToRefs(systemStore)


const FootComponent = ref(null)
const LoginComponent = ref(null)
const NavComponent = ref(null)
const OpenAppComponent = ref(null)

const showRoute = ref(false)

const showAgreement = ref(isEurop.value && import.meta.env.VITE_FOOT_AGREEMENT)
const sawAgreement = ref(!!localStorage.getItem('agreeCookies'))

const footVisible = computed(() => {
  let footVisibleList = ['thread', 'circle', 'user', 'webCommunityTimes', 'privacyPolicy', 'privacyNotice', 'userAgreement', 'myCircles', 'allCircles', 'termsOfUse', 'useOfCookies', 'raffleForm', 'form', 'powerOfCommunity', 'product', 'lifeStudioProduct', 'lifeStudio', 'ShotonOPPO', 'merchaindise', 'message', 'oneplusMeetup', 'oppoMeetup']
  const visible = footVisibleList.includes(route.name) && isWeb.value
  // 展示页脚时页面容器的内容高度和底部边距
  // document.querySelector('#app').style.paddingBottom = visible ? '144px' : 0
  return visible
})

const openAppVisible = computed(() => {
  // 是否展示跳转app按钮
  let openAppVisibleList = ['home', 'thread']
  return openAppVisibleList.includes(route.name) && isWap.value && (!isApp.value || isAppMarket.value) && !isWechat.value && !(import.meta.env.VITE_COUNTRY === 'IN')
})

function linkToCookies () {
  if (import.meta.env.VITE_COUNTRY === 'PARIS') {
    window.open('https://www.oneplus.com/uk/legal/use-of-cookies')
  } else {
    this.$router.push({
      path: 'privacy_notice'
    })
  }
}

function closeCookie () {
  sawAgreement.value = true
  localStorage.setItem('agreeCookies', true)
}

function redirectInterceptor () {
  document.addEventListener('click', (e) => {
    const { tagName, dataset, href } = e.target ?? {}
    let locationTarget = {}
    try {
      locationTarget = new URL(href)
    } catch {
      locationTarget = {}
    }
    const redirectWhiteList = customSetting.value.redirectWhiteList || []
    const isInWhiteList = redirectWhiteList.some(i => locationTarget.host?.includes(i))
    if (tagName === 'A' && dataset.type === 'link' && !isInWhiteList) {
      e.preventDefault()
      const dialogData = reactive({
        visible: true,
        width: isWeb.value ? 464 : (document.documentElement.clientWidth - 32),
        zIndex: 4999,
        title: proxy.$t('common.linkRedirect'),
        content: href,
        footer: true,
        confirmText: proxy.$t('common.continue'),
        cancelText: proxy.$t('common.cancel'),
        translate: false,
        showCancelIcon: false,
        onConfirmCallback: (callbackData) => {
          callbackData.value = false
          window.open(href)
        },
      })
      renderDialog(dialogData)
      return
    }
  }, { capture: true })
}



watch(route, async (val) => {
  if (!val.name) return
  try {
    const isOppoAppLoginPage = isOppoApp.value && val.name === 'opLogin'
    if (isApp.value && !isOppoAppLoginPage) {
      if (appName.value === 'oneplusApp' ) {
        // 1+app不展示H5头部
        if (!val.meta.privacy) {
          proxy.$hideClientTitle()
        } else {
          document.body.className = document.body.className.replace('app', '')
        }
      } else {
        proxy.$hideClientTitle()
      }
    }
  } catch (e) {
    console.log(e)
  }
}, {
  immediate: true,
  deep: true
})

onBeforeMount(async () => {
  // 组件切换
  if (window.innerWidth >= 1024) {
    NavComponent.value = markRaw(defineAsyncComponent(() => import('@/components/web/webNav')))
    FootComponent.value = markRaw(defineAsyncComponent(() => import('@/components/web/footer')))
  } else {
    NavComponent.value = markRaw(defineAsyncComponent(() => import('@/components/wap/wapNav')))
    OpenAppComponent.value = markRaw(defineAsyncComponent(() => import('@/components/wap/openApp')))
    LoginComponent.value = markRaw(defineAsyncComponent(() => import('@/components/login')))
  }
  if (isApp.value) {
    const bodyClassName = document.body.className
    // 仅myoppo容器为全容器，电池栏不占位，需要调整高度
    if (!bodyClassName.includes('app')) {
      document.body.className += ' app'
    }
    if (!bodyClassName.includes(appName.value)) {
      document.body.className += ` ${appName.value}`
    }
    // 获取应用登录态
    if (!uid.value) {
      await proxy.$getToken()
    }
    switch (appName.value) {
      case 'myOppo':
        // webView容器聚焦，聚焦重新获取token
        proxy.$onResume(async () => {
          await proxy.$getToken()
        })
        break
      case 'oppoApp':
      case 'oneplusApp':
        // 获取app版本并记录
        const { data } = await proxy.$getDeviceInfo()
        systemStore.versionCode = Number(data.versionCode)
        systemStore.injectWebView = Number(data.injectWebView)
        break
      default:
    }
    // app系统语言同步
    let defaultLanguage = {
      name: 'English',
      value: 'en-GB'
    }
    try {
      if (route.name !== 'abroadList') {
        const { data } = await proxy.$getClientContext()
        let appLanguage = (data.languageTag || data.lang)
        defaultLanguage = languageList.find(i => i.value ===(appLanguage)) || {
          name: 'English',
          value: 'en-GB'
        }
        if (isCommunityApp.value) {
          appLanguage =(data.languageTag || data.lang)?.split('-')[0]
          defaultLanguage = languageList.find(i => i.value.includes(appLanguage)) || {
            name: 'English',
            value: 'en-GB'
          }
        }
      }
    } catch (e) {}
    localStorage.setItem('communityLanguage', JSON.stringify(defaultLanguage))
    proxy.$i18n.locale = defaultLanguage.value
    systemStore.setLanguage(defaultLanguage.value)
  } else {
    setRootCssProperties({
      '--orbit-status-bar-height': '0px'
    })
  }
  systemStore.getAssociationList()
  systemStore.getReportTaskList() // 客户端获取上报任务列表
})

onMounted(async () => {
  window.addEventListener('focus', onFocus);
  window.addEventListener('blur', onBlur);
  // 全局灰色主题
  if (cloudConfig.value.functionSwitch?.grayTheme) {
    const className =  document.documentElement.style = `
      -webkit-filter: grayscale(1); /* Old Chrome、Old Safari、Old Opera*/
      filter: grayscale(1); /* 现代浏览器标准 */
      filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
    `
  }
  // 国内神策埋点初始化
  if (import.meta.env.VITE_COUNTRY === 'CHINA') {
    proxy.$ga('', {}, 'init')
  }
})

onMounted(() => {
  nextTick(() => {
    //注册push
    regPush()
    // 全局拦截链接跳转
    redirectInterceptor()
  })
})

onUnmounted(async () => {
  window.removeEventListener('focus', onFocus);
  window.removeEventListener('blur', onBlur);
})


</script>

<style lang="postcss" scoped>
.cookie-bottom {
  position: fixed;
  width: 100%;
  bottom: 0;
  background-color: rgba(255,255,255,0.9);
  padding: 20px 44px 20px 30px;
  box-sizing: border-box;
  z-index: 9999;
  p {
    padding: 0;
    line-height: 16px;
    font-size: 11px;
    color: rgba(0, 0, 0, .7);
    a {
      display: inline;
      text-decoration: underline;
      cursor: pointer;
      font-size: 11px;
      color: rgba(0, 0, 0, .7);
    }
  }
  .cookie-close {
    width: 18px;
    height: 18px;
    position: absolute;
    right: 30px;
    top: 20px;
    cursor: pointer;
  }
  .svg-icon {
    width: 18px;
    height: 18px;
  }
}
.cookie-bottom-wap {
  position: fixed;
  width: 100%;
  bottom: 0;
  padding: .2rem .5rem .2rem .2rem;
  background-color: rgba(255,255,255,0.9);
  z-index: 1000;
  p {
    font-size: .12rem;
    color: rgba(0, 0, 0, .7);
    a {
      display: inline;
      text-decoration: underline;
      font-size: .12rem;
      color: rgba(0, 0, 0, .7) !important;
    }
  }
  .cookie-close {
    position: absolute;
    right: .2rem;
    bottom: 0;
    top: 0;
    margin: auto;
  }
  .svg-icon {
    width: .24rem;
    height: .24rem;
  }
}
</style>
